import { render } from "./webLink.vue?vue&type=template&id=49e4603a"
import script from "./webLink.vue?vue&type=script&lang=js"
export * from "./webLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__